






















































































































































































import {
  defineComponent,
  useAsync,
  useContext,
  useRoute,
  useRouter,
  onMounted,
  reactive,
  ref,
  computed,
  watch,
  getCurrentInstance
} from '@nuxtjs/composition-api'
import ImagepixPicture from 'imagepix-vue2'
import BookmarkButton from '~/components/career/job_offers/BookmarkButton.vue'
import Paginator, {
  PaginationHeaders,
  calculateTotalFromHeaders
} from '~/components/Paginator.vue'
import Accordion from '~/components/career/Accordion.vue'
import useCookies from '~/composables/useCookies'
import useAllMasterData from '~/composables/useAllMasterData'
import useProfileApis from '~/composables/careers/useProfileApis'
import Meta from '~/assets/mixins/meta'
import useFlashMessage from '~/composables/useFlashMessage'
import dayjs, { postDaysAgo } from '~/libs/dayjs'
// @ts-ignore
import IconPlaceSvg from '~/assets/images/svg/icon_place.svg?inline'
// @ts-ignore
import ArrowBottomSvg from '~/assets/images/svg/arrow_bottom.svg?inline'
// @ts-ignore
import IconSearchSvg from '~/assets/images/header/icon-search.svg?inline'
// @ts-ignore
import IconPaySvg from '~/assets/images/svg/icon_pay.svg?inline'
// @ts-ignore
import IconVideoSvg from '~/assets/images/svg/icon_video.svg?inline'
import { truncate } from '~/libs/utils'
import AdviserModal from '~/components/career/AdviserModal.vue'
import { simpleFormat } from '~/libs/common'

const AVAILABLE_SORTS = [
  'minimum_income+desc',
  'updated_at+desc',
  'recruiting_begin_at+desc'
]

export default defineComponent({
  components: {
    BookmarkButton,
    ImagepixPicture,
    Paginator,
    Accordion,
    IconPlaceSvg,
    ArrowBottomSvg,
    IconSearchSvg,
    IconPaySvg,
    IconVideoSvg,
    AdviserModal,
    simpleFormat
  },
  layout: 'career',
  mixins: [Meta],
  data() {
    return {
      isSearchMenu: false
    }
  },
  setup() {
    const { $axios, $auth } = useContext()
    const route = useRoute()
    const $cookies = useCookies()
    const {
      jobOfferEmploymentStatuses,
      offeringJobRoles,
      industries,
      jobOfferTags,
      softwares
    } = useAllMasterData()
    const { fetchProfile } = useProfileApis()
    const router = useRouter()
    const { showFlashAlertMessage } = useFlashMessage()
    const { $modal } = getCurrentInstance()!.proxy

    const sort = computed(() => {
      const sort = route.value.query.sort as string | null
      return AVAILABLE_SORTS.includes(sort || '')
        ? sort
        : 'recruiting_begin_at+desc'
    })

    const changeSort = (event: Event) => {
      const target = event.target as HTMLSelectElement
      const query = { ...route.value.query }
      if (target.value === 'recruiting_begin_at+desc') {
        delete query.sort
      } else {
        query.sort = target.value
      }
      router.push({ query })
    }

    const fetchJobOffers = async () => {
      const query: any = []
      if (route.value.query.direct) {
        query.push(`q[direct_eq]=${route.value.query.direct}`)
      }
      if (route.value.query.role) {
        query.push(`q[offering_job_role_id_eq]=${route.value.query.role}`)
      }
      if (route.value.query.status) {
        query.push(`q[employment_status_id_eq]=${route.value.query.status}`)
      }
      if (route.value.query.tag) {
        query.push(
          `q[job_offers_tags_careers_job_offer_tag_id_eq]=${route.value.query.tag}`
        )
      }
      if (route.value.query.industry) {
        query.push(
          `q[job_offers_industries_industry_id_eq]=${route.value.query.industry}`
        )
      }
      if (route.value.query.software) {
        query.push(
          `q[job_offers_softwares_software_id_eq]=${route.value.query.software}`
        )
      }

      if (route.value.query.page) {
        query.push(`page=${route.value.query.page}&per=10`)
      }

      query.push(`q[s]=${sort.value}`)

      const { data, headers } = await $axios.get<careers.JobOffer[]>(
        `/careers/job_offers?${query.join('&')}`
      )
      return {
        data,
        headers: headers as PaginationHeaders
      }
    }

    const response = useAsync(() => fetchJobOffers(), route.value.fullPath)

    const profile = ref<careers.Profile | null>()

    const getCareerAdviser = (jobOffer: careers.JobOffer) => {
      if (jobOffer.application_completed) {
        showFlashAlertMessage('すでに応募済みです。')
        return
      }

      $cookies.set('jobsPage', `/jobs/${jobOffer.id}`)

      if (!$auth.loggedIn) {
        $cookies.set('afterCareerRegistrationPath', route.value.path)
        $cookies.set('afterLoginURL', `${process.env.BASE_URL}/registration`, {
          domain: process.env.COOKIE_DOMAIN
        })
        showFlashAlertMessage('ログインしてください。')
        router.push('/sign_in')
      } else if (profile.value?.completed) {
        $modal.show(jobOffer.title)
      } else {
        router.push('/registration')
      }
    }

    const transitDirectEntry = (jobOffer: careers.JobOffer) => {
      if (jobOffer.application_completed) {
        showFlashAlertMessage('すでに応募済みです。')
        return
      }

      if (!$auth.loggedIn) {
        $cookies.set('afterCareerRegistrationPath', route.value.path)
        $cookies.set('afterLoginURL', `${process.env.BASE_URL}/registration`, {
          domain: process.env.COOKIE_DOMAIN
        })
        showFlashAlertMessage('ログインしてください。')
        router.push('/sign_in')
      } else if (profile.value?.completed) {
        router.push(`/jobs/${jobOffer.id}/direct`)
      } else {
        router.push('/registration')
      }
    }

    const currentStatus = computed(() => {
      return jobOfferEmploymentStatuses.value.find(
        (obj: Master) => obj.id === Number(route.value.query.status)
      )?.name
    })

    const currentRole = computed(() => {
      return offeringJobRoles.value.find(
        (obj: Master) => obj.id === Number(route.value.query.role)
      )?.name
    })

    const currentIndustry = computed(() => {
      return industries.value.find(
        (obj: Master) => obj.id === Number(route.value.query.industry)
      )?.name
    })

    const currentTag = computed(() => {
      return jobOfferTags.value.find(
        (obj: Master) => obj.id === Number(route.value.query.tag)
      )?.name
    })

    const currentSoftware = computed(() => {
      return softwares.value.find(
        (obj: Master) => obj.id === Number(route.value.query.software)
      )?.name
    })

    const title = computed(() => {
      const getName = (objs: Master[], id: any) => {
        return objs.find((obj: Master) => obj.id === Number(id))?.name
      }

      let output = ''
      if (route.value.query.status) {
        output =
          output +
          getName(jobOfferEmploymentStatuses.value, route.value.query.status) +
          ' / '
      }
      if (route.value.query.role) {
        output =
          output +
          getName(offeringJobRoles.value, route.value.query.role) +
          ' / '
      }
      if (route.value.query.industry) {
        output =
          output + getName(industries.value, route.value.query.industry) + ' / '
      }
      if (route.value.query.tag) {
        output =
          output + getName(jobOfferTags.value, route.value.query.tag) + ' / '
      }
      if (route.value.query.software) {
        output =
          output + getName(softwares.value, route.value.query.software) + ' / '
      }
      return output.slice(0, output.length - 3)
    })

    onMounted(() => {
      if ($auth.loggedIn) {
        fetchProfile().then((data) => {
          profile.value = data
        })
      }
    })

    const jobOffers = computed(() => response.value?.data)

    const page = computed(() => {
      const page = route.value.query.page as string | null
      return page ? parseInt(page) : 1
    })

    const total = computed(() =>
      response.value?.headers
        ? calculateTotalFromHeaders(response.value.headers)
        : 0
    )

    const metaTitle = computed((): string => {
      if (title.value) {
        return `${title.value}の求人`
      } else {
        return '求人情報一覧'
      }
    })

    const meta = reactive({
      title: metaTitle,
      image: require('~/assets/images/career/ogp.jpg')
    })

    watch(
      () => route.value.query,
      async () => {
        response.value = await fetchJobOffers()
        window.scrollTo({ top: 0 })
      }
    )

    const directParam = computed(() => {
      if (route.value.query.direct) {
        return '&direct=true'
      } else {
        return ''
      }
    })

    const statusParam = computed(() => {
      if (route.value.query.status) {
        return '&status=' + route.value.query.status
      } else {
        return ''
      }
    })

    const roleParam = computed(() => {
      if (route.value.query.role) {
        return '&role=' + route.value.query.role
      } else {
        return ''
      }
    })

    const industryParam = computed(() => {
      if (route.value.query.industry) {
        return '&industry=' + route.value.query.industry
      } else {
        return ''
      }
    })

    const tagParam = computed(() => {
      if (route.value.query.tag) {
        return '&tag=' + route.value.query.tag
      } else {
        return ''
      }
    })

    const softwareParam = computed(() => {
      if (route.value.query.software) {
        return '&software=' + route.value.query.software
      } else {
        return ''
      }
    })

    const queryParam = computed(() => {
      if (route.value.query.direct) {
        return { ...route.value.query }
      } else {
        return { ...route.value.query, direct: true }
      }
    })

    return {
      meta,
      sort,
      changeSort,
      jobOfferEmploymentStatuses,
      offeringJobRoles,
      industries,
      jobOfferTags,
      softwares,
      jobOffers,
      title,
      profile,
      page,
      total,
      getCareerAdviser,
      transitDirectEntry,
      postDaysAgo,
      directParam,
      queryParam,
      statusParam,
      roleParam,
      tagParam,
      softwareParam,
      industryParam,
      currentStatus,
      currentRole,
      currentIndustry,
      currentTag,
      currentSoftware,
      simpleFormat
    }
  },
  methods: {
    truncate,
    formatDataJa(date: any) {
      return dayjs(date).format('YYYY年MM月DD日')
    }
  }
})
